//THIS BUSINESS COMPONENT RELATES TO GENERATING AND DOWNLOADING OF INVITATION calendarEnd
//IT TAKES THE WEB API RETURENED INVITATIONDETAIL AS INPUT
//IT THEN PICKS THE TEMPLATE OBJECT FROM LANGUAGE AND REPLACE THE #TAGS WITH LIVE ACTUAL DATA
export class GenerateInviteDetail {
  //CALLS FROM OUTSIDE, PASS THE INVITATIONDETAIL OBJECT RETURNED VIA WEBAPI
  static downloadInvitationCalendar(invitationDetails) {
    let template = APP.LANGUAGE.Templates.InviteCalendar,
      tags = APP.LANGUAGE.Templates.InviteTags,
      { inviterName, inviterTelephone, password, roomId, roomName, roomUrl } = invitationDetails,
      extension = '.ics', //AT THE MOMENT THE EXTENSION IS ICS
      filename = GenerateInviteDetail.parseWithTemplate(invitationDetails, template.FileName); //REPLACE THE FILENAME WITH ACTUAL DATA
    if (!filename) filename = 'Invitation'; //IF THERE IS ANY PROBLEM THEN KEEP THE FILENAME TO INVITATION

    var inviteDetails = GenerateInviteDetail.getInvitationCalendar(invitationDetails); //RETURNS THE ICS FORMATTED STRING INCLUDING ALL THE DETAILS LIKE SUBJECT, LOCATION ETC
    if (inviteDetails) {
      //IF THERE IS VALID INVITE DETAILS
      console.log('i am in download' + inviteDetails);
      //NOW WE ARE PREPARING FOR THE DOWNLOAD OF THE FILE. PREPARING A LINK SET THE BLOB URL AS HREF
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      var blob = new Blob([inviteDetails], { type: 'plain/text' }),
        url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = filename + extension;
      a.click();
      setTimeout(function () {
        console.log('i am removing');
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 100);
    }
  }
  //REPLACE THE PASSED STRING WITH DATA FROM ACTUAL OBJECT, USING THE HASHTAGS
  static parseWithTemplate(dataObject, toParseString) {
    let tags = APP.LANGUAGE.Templates.InviteTags;
    tags.map((tag) => {
      toParseString = toParseString.replace(new RegExp(tag['Tag'], 'g'), dataObject[tag['Column']]);
    });
    return toParseString;
  }

  static getInvitationCalendar(invitationDetails) {
    //PREPARING BODY,SUBject, Location of the invitation
    let template = APP.LANGUAGE.Templates.InviteCalendar,
      description = JSON.stringify(template.Body);
    description = GenerateInviteDetail.parseWithTemplate(invitationDetails, description);
    description = description
      .split('')
      .splice(1, description.length - 2)
      .join(''); //removing quotes from end
    var subject = GenerateInviteDetail.parseWithTemplate(invitationDetails, template.Subject);
    var location = GenerateInviteDetail.parseWithTemplate(invitationDetails, template.Location);

    //End PREPARING

    //Preparing ICS file format
    //Code used from : https://github.com/nwcell/ics.js/blob/master/ics.js
    var SEPARATOR = navigator.appVersion.indexOf('Win') !== -1 ? '\r\n' : '\n';
    var calendarEvents = [];

    var calendarStart = ['BEGIN:VCALENDAR', 'VERSION:2.0'].join(SEPARATOR);

    var calendarEvent = [
      'BEGIN:VEVENT',
      'CLASS:PUBLIC',
      'DESCRIPTION:' + description,
      'LOCATION:' + location,
      'SUMMARY;LANGUAGE=en-us:' + subject,
      'TRANSP:TRANSPARENT',
      'END:VEVENT',
    ].join(SEPARATOR);
    calendarEvents.push(calendarEvent);

    var calendarEnd = SEPARATOR + 'END:VCALENDAR';

    return calendarStart + SEPARATOR + calendarEvents + calendarEnd;
    //End ICS file format
  }
}
